import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';

import { SortEvent } from '../../domain/public-api';
import { BaseValueAccessor } from '../../components/value-accessor/base-value-accessor';
import { ValueAccessorProviderFactory } from '../../components/value-accessor/value-accessor-provider-factory';
import { SideSheetSelectorItemComponent } from '../../components/side-sheet-selector/side-sheet-selector-item.component';
import { SideSheetSelectorToggleDirective } from '../../components/side-sheet-selector/side-sheet-selector-toggle.directive';
import { SideSheetSelectorComponent } from '../../components/side-sheet-selector/side-sheet-selector.component';
import { DropdownItemComponent } from '../../components/dropdown/dropdown-item.component';
import { DropdownToggleDirective } from '../../components/dropdown/dropdown-toggle.directive';
import { DropdownComponent } from '../../components/dropdown/dropdown.component';
import { SortDirection } from '../../components/datatable/types/sort-direction.type';
import { TableSort } from '../../components/datatable/types/sort.type';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { SortByDefinition, SortByOption, SortByOptionHelper } from './sort-by-selector.domain';

@Component({
  selector: 'td-wb-sort-by-selector',
  templateUrl: 'sort-by-selector.component.html',
  styleUrls: ['sort-by-selector.component.scss'],
  providers: [ValueAccessorProviderFactory(SortBySelectorComponent)],
  imports: [
    SideSheetSelectorItemComponent,
    UpperCasePipe,
    SideSheetSelectorToggleDirective,
    SideSheetSelectorComponent,
    FormsModule,
    TranslatePipe,
    TranslateDirective,
    DropdownItemComponent,
    DropdownToggleDirective,
    DropdownComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortBySelectorComponent extends BaseValueAccessor<SortByOption> implements OnInit {
  @Input() panelMaxHeight: number;
  @Input() columns: Array<SortByDefinition>;
  @Input() sortBy: SortByOption;
  @Input() type: 'dropdown' | 'slide' = 'dropdown';
  @Output() readonly sortByChange: EventEmitter<SortEvent | SortByOption> = new EventEmitter<SortEvent | SortByOption>();

  sortByOptions: Array<SortByOption> = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initSortByOptions();
  }

  onModelChange(event: SortByOption): void {
    this.value = event;
    this.sortByChange.next(event);
  }

  comparator(sortByFirst: SortByOption, sortBySecond: SortByOption): boolean {
    return SortByOptionHelper.comparator(sortByFirst, sortBySecond);
  }

  setSortBy(sort: TableSort): void {
    this.sortBy = SortByOptionHelper.convertFromTableSort(sort, this.columns);
    this.sortByChange.next(this.sortBy);
  }

  private initSortByOptions(): void {
    this.columns.forEach((def: SortByDefinition): void => {
      this.sortByOptions.push({ ...def, direction: SortDirection.ASC });
      this.sortByOptions.push({ ...def, direction: SortDirection.DESC });
    });
  }

}
